import { gql } from 'graphql-request';

// Sprint 25, story-133. `getProjectWeather` reads only stored rows and never blocks on NOAA — see
// docs/architecture.md's `## Sprint 25` -> story-133.
export const getProjectWeather = gql`
  query getProjectWeather($projectId: String!, $from: String!, $to: String!) {
    getProjectWeather(projectId: $projectId, from: $from, to: $to) {
      date
      kind
      condition
      highTemp
      lowTemp
      precipitation
      precipChance
      fetchedAt
      station
    }
  }
`;

const WeatherGraphQL = {
  queries: {
    getProjectWeather,
  },
};

export default WeatherGraphQL;
